var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#5F5FFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4935 11.2673C26.0935 5.10732 20.7201 2.33398 16.0001 2.33398C16.0001 2.33398 16.0001 2.33398 15.9868 2.33398C11.2801 2.33398 5.89346 5.09398 4.49346 11.254C2.93346 18.134 7.14679 23.9607 10.9601 27.6273C12.3735 28.9873 14.1868 29.6673 16.0001 29.6673C17.8135 29.6673 19.6268 28.9873 21.0268 27.6273C24.8401 23.9607 29.0535 18.1473 27.4935 11.2673ZM16.0001 17.9473C13.6801 17.9473 11.8001 16.0673 11.8001 13.7473C11.8001 11.4273 13.6801 9.54732 16.0001 9.54732C18.3201 9.54732 20.2001 11.4273 20.2001 13.7473C20.2001 16.0673 18.3201 17.9473 16.0001 17.9473Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.b9897a19fe2f798586f73eaba6ce53f5.svg";
export { ForwardRef as ReactComponent };